<a
    appInterceptLinks
    [attr.href]="link.url | withParams: queryParams"
    [title]="label ?? link.name"
    [target]="link.target || '_self'"
    rel="noopener noreferrer"
    [ngClass]="[cover ? 'kk-link-cover' : '', styleClass]"
    [ngStyle]="inlineStyle"
    (focus)="focusEvent.emit($event)"
    (mouseenter)="focusEvent.emit($event)"
    (keyup.enter)="focusEvent.emit($event)"

>
    <span #content>
        <ng-content></ng-content>
    </span>

    {{ content.hasChildNodes() ? null : link.name }}
</a>
